'use client'

import { twMerge } from 'tailwind-merge'
import { useState, forwardRef } from 'react'
import _ from 'lodash'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

type Props = {
  className?: string
  label?: string
  name: string
  value?: string
  placeholder?: string
} & React.ComponentPropsWithoutRef<'input'>

export const Password = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { className, id, name, label, onChange, onBlur } = props
  const [showPassword, setShowPassword] = useState(false)
  const errMsg = _.get(props, 'data-error')
  return (
    <div className='w-full'>
      <label htmlFor={id || name} className='form-label'>
        {label || 'Password'}
      </label>
      <div className='mt-1 flex rounded form-container'>
        <input
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          id={id || name}
          name={name}
          type={showPassword ? 'text' : 'password'}
          className={twMerge('form-default form-input rounded-r-none!', className, errMsg && 'form-input-error')}
        />
        <button
          tabIndex={-1}
          type='button'
          className='form-addon-button'
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeSlashIcon className='w-5' /> : <EyeIcon className='w-5' />}
        </button>
      </div>
      {
        errMsg && <div className='form-error-message'>{errMsg}</div>
      }
    </div >
  )
})

